import { Divider, Stack, Box } from '@mui/material';

export function DividerWithContent({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Stack
      direction='row'
      useFlexGap
      sx={{
        alignItems: 'center',
        marginTop: 3,
        gap: 1,
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
        }}
      >
        <Divider />
      </Box>
      {children}
      <Box
        sx={{
          flexGrow: 1,
        }}
      >
        <Divider />
      </Box>
    </Stack>
  );
}
